
























































































import * as _ from "lodash";
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  getGuanchazhibiaoAndBiaoqian,
  getBiaoqianList,
  saveBiaoqianList,
  saveGuanchazhibiaoAndBiaoqian
} from "@/request/idr";
import SelectMultiSearch from "../../components/select-multi-search-detail.vue";
@Component({
  components: {
    SelectMultiSearch
  }
})
export default class IdrTongueBiaozhuYanse extends Vue {
  @Prop()
  private tongueId: any;
  @Prop()
  private tongue: any;
  private loaded: boolean = false;
  private labels: any[] = [];
  private ifShowAddLabel: boolean = false;
  private tempLabels: any[] = [];
  private get message() {
    return this.tongue;
  }
  /**
   * @description 获得标签详情
   */
  private fetchDetail() {
    this.$emit("refresh");
  }
  /**
   * @description 获得可选的标签列表
   */
  private fetchBiaoqianList() {
    return new Promise((resolve, reject) => {
      getBiaoqianList(this)
        .then((data: any) => {
          this.labels = data;
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 将标签添加到分组标签
   */
  private addLabelToFenzu(item) {
    this.message["分组标签"].push(item);
    this.message["分组标签"] = _.uniqBy(this.message["分组标签"], "id");
    (this.$refs.biaoqianSelect as any).addOption();
  }
  /**
   * @description 打开添加标签弹窗
   */
  private openAddLabel() {
    this.tempLabels = _.cloneDeep(this.labels);
    if (this.tempLabels.length === 0) {
      this.$set(this.tempLabels, "0", { 名称: "" });
    }
    this.ifShowAddLabel = true;
  }
  /**
   * @description 关闭弹窗
   */
  private closeAddLabel() {
    this.ifShowAddLabel = false;
  }
  /**
   * @description 添加临时标签
   */
  private addLabel() {
    this.tempLabels.unshift({ 名称: "" });
  }
  /**
   * @description 删除一个标签
   */
  private deleteLabel(index) {
    if (this.tempLabels.length === 1) {
      this.tempLabels = [{ 名称: "" }];
    } else {
      this.tempLabels.splice(index, 1);
    }
  }
  /**
   * @description 保存对标签的修改
   */
  private saveAddedLabel() {
    const params: any = {
      tags: this.tempLabels
    };
    saveBiaoqianList(this, params).then(() => {
      this.$message.success("修改成功");
      this.ifShowAddLabel = false;
      this.tempLabels = [];
    });
  }
  /**
   * @description 根据新的标签列表，筛选已选标签
   */
  private filterSelectedLables() {
    this.message["分组标签"].forEach((item: any, index: any) => {
      if (
        !_.find(this.labels, (i: any) => {
          return i.id === item.id;
        })
      ) {
        this.message["分组标签"].splice(index, 1);
      }
    });
  }
  /**
   * @description 刷新页面
   */
  private refresh() {
    this.fetchBiaoqianList().then(() => {
      this.filterSelectedLables();
    });
  }
  /**
   * @description 保存标签
   */
  private saveBiaoqian(guiji) {
    const params: any = _.cloneDeep(this.message);
    params["轨迹"] = guiji;
    params["舌象照片"] = this.tongue["舌象照片"];
    saveGuanchazhibiaoAndBiaoqian(this, params).then((data: any) => {
      this.$message.success("修改成功");
      this.fetchDetail();
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchBiaoqianList();
  }
}
